export default "__VITE_PUBLIC_ASSET__a842cf1e__"